import { render, staticRenderFns } from "./UnsubscribeLanding.vue?vue&type=template&id=705ecf70&scoped=true"
import script from "./UnsubscribeLanding.vue?vue&type=script&lang=js"
export * from "./UnsubscribeLanding.vue?vue&type=script&lang=js"
import style0 from "./UnsubscribeLanding.vue?vue&type=style&index=0&id=705ecf70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705ecf70",
  null
  
)

export default component.exports